import { FunctionalComponent, h } from '@stencil/core';

interface AafpTextLinkProps {
  link: HTMLElement;
  description?: string;
  [key: string]: any;
  subText?: string;
}

export const AafpTextLink: FunctionalComponent<AafpTextLinkProps> = ({ description, link, subText }) => (
  <div class="adl-text-link">
    <div class="adl-text-link__aafp-link" ref={el => el && el.append(link)}></div>
    {subText ? (
      <div class="adl-list-item">
        <div class="adl-body adl-text-link__sub-text">{subText}</div>
      </div>
    ) : (
      ''
    )}
    {description && <div class="adl-list-item">{description}</div>}
  </div>
);
